// File: src/services/TeltonikaSvc.js
import axiosInstance, { getNewCancelToken } from '@/services/_AxiosInstance';

/**
 * Service untuk mengelola data Teltonika (GPS, Pulse, dll.)
 * @namespace TeltonikaSvc
 */
export default {
  /**
   * Mendapatkan data terakhir untuk satu atau lebih perangkat Teltonika.
   * @function getLastData
   * @param {Array<string|number>} deviceIds - Array berisi ID perangkat yang ingin diambil datanya.
   * @param {object} params - Parameter tambahan untuk request.
   * @return {Promise} Promise yang berisi response dari server.
   */
  getLastData: async (deviceIds, params) => {
    // Membangun string query untuk multiple device IDs
    // Contoh: device[]=id1&device[]=id2
    const deviceQuery = deviceIds.map((id) => `device[]=${id}`).join('&');
    const { data } = await axiosInstance.get(`/series/teltonika/gps/pulse?${deviceQuery}&timezone=7`, {
      params: {
        ...params,
      },
      cancelToken: getNewCancelToken(),
    });
    return data;
  },

  /**
   * Mendapatkan data periodik yang diagregasi untuk satu atau lebih perangkat Teltonika.
   * @function getPeriodData
   * @param {number} start - Timestamp awal dalam detik.
   * @param {number} end - Timestamp akhir dalam detik.
   * @param {string} aggregatedUnit - Unit agregasi (MINUTE, HOUR, DAY).
   * @param {Array<string|number>} deviceIds - Array berisi ID perangkat yang ingin diambil datanya.
   * @param {number} [timezone=7] - Offset zona waktu.
   * @param {number} [aggregatedLength=15] - Panjang agregasi.
   * @return {Promise} Promise yang berisi response dari server.
   */
  getPeriodData: async (start, end, aggregatedUnit, deviceIds, timezone = 7, aggregatedLength = 15) => {
    // Membangun string query untuk multiple device IDs
    const deviceQuery = deviceIds.map((id) => `device[]=${id}`).join('&');
    const { data } = await axiosInstance.get(`/series/aggregated/teltonika/gps/period/${start}/${end}?aggregatedUnit=${aggregatedUnit}&${deviceQuery}&timezone=${timezone}&aggregatedLength=${aggregatedLength}`, {
      cancelToken: getNewCancelToken(),
    });
    return data;
  },
};
